export function useEventListeners(context) {
	const listeners = new Map();

	function addListener(target, event, handler) {
		if (!target) {
			console.warn("Can't add listener. Not a valid target");
			return;
		}

		const boundHandler = handler.bind(context);
		listeners.set(handler, { target, event, boundHandler });
		target.addEventListener(event, boundHandler);
	}

	function removeListener(target, event, handler) {
		const entry = listeners.get(handler);
		if (entry) {
			target.removeEventListener(event, entry.boundHandler);
			listeners.delete(handler);
		}
	}

	function removeAllListeners() {
		for (const { target, event, boundHandler } of listeners.values()) {
			target.removeEventListener(event, boundHandler);
		}
		listeners.clear();
	}

	return {
		addListener,
		removeListener,
		removeAllListeners,
	};
}


/**
 *
 * @param {Event} e
 * @param {String} selector
 * @returns {HTMLElement|null}
 */
export function getElementFromEvent(e, selector) {
	if (!e.target) {
		return null;
	}

	const el = e.target?.closest(selector);

	if (!el) {
		return null;
	}

	return el;
}

export function getKeyboardFocusableElements(element = document) {
	return [
		...element.querySelectorAll(
			'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
		),
	].filter((el) => {
		const style = window.getComputedStyle(el);

		const isVisible = style.display !== 'none' && style.visibility !== 'hidden';
		const isNotDisabled = !el.hasAttribute('disabled');
		const isNotAriaHidden = el.getAttribute('aria-hidden') !== 'true';
		const isNotInert = !el.hasAttribute('inert');

		return isVisible && isNotDisabled && isNotAriaHidden && isNotInert;
	});
}


export function isElement(element) {
	return element instanceof Element || element.nodetype == Node.DOCUMENT_NODE;
}

export function loadCSS(url) {
	return new Promise((resolve, reject) => {
		const filename = url.split('/').pop();
		const styleTags = document.head.querySelectorAll('link[rel="stylesheet"]');
		let styleExists = false;

		styleTags.forEach((tag) => {
			if (tag.href && tag.href.includes(filename)) {
				styleExists = true;
			}
		});

		if (styleExists) {
			resolve();
			return;
		}

		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = url;
		link.onload = () => resolve();
		link.onerror = () => reject(new Error(`CSS load failed: ${url}`));
		document.head.appendChild(link);
	});
}